const state = {
  selected: {
    type: "",
    state: "",
    rep: "",
  },
};

const selects = {
  type: {
    selector: ".dealer-type, .dealer-box",
    key: "type",
    label: "Dealer Type",
  },
  state: {
    selector: ".area-select",
    key: "state",
    label: "Select the Area Nearest You",
  },
  rep: {
    selector: ".rep-type",
    key: "customer_number",
    label: "Select the Rep Type",
  },
};
function getQueryParam(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name) || "";
}

function showLoader() {
  const loader = document.getElementById("dealer-loading");
  if (loader) loader.style.display = "flex";
}

function hideLoader() {
  const loader = document.getElementById("dealer-loading");
  if (loader) loader.style.display = "none";
}

let currentPage = 1;
const dealersPerPage = 12;
let currentDealers = [];

function renderDealers(dealers, resetPage = true) {
  const grid = document.querySelector(".dealer-grid");
  const count = document.querySelector(".dealer-grid-container");
  const loader = document.getElementById("dealer-loading");
  const loadMoreBtn = document.getElementById("load-more-dealers");

  if (resetPage) {
    currentPage = 1;
    currentDealers = dealers;
    grid.innerHTML = ""; // Only clear when resetting
  }

  // Remove existing count paragraph if already added
  const existingCount = count.querySelector(".dealer-count");
  if (existingCount) existingCount.remove();

  const p = document.createElement("p");
  p.classList.add("dealer-count");
  p.style.display = "block";
  p.innerHTML = `Over <span>${dealers.length} dealers</span> available in your ZIP code or Location.`;
  count.insertBefore(p, loader);

  const start = (currentPage - 1) * dealersPerPage;
  const end = start + dealersPerPage;
  const dealersToRender = dealers.slice(start, end);

  dealersToRender.forEach((dealer) => {
    const websiteUrl = dealer.site?.startsWith("http")
      ? dealer.site
      : `https://${dealer.site}`;
    const card = document.createElement("div");
    card.className = "dealer-card";
     let imageName = dealer.image || "tempest-logo.svg?v=1749618687";

  // Lowercase only the extension (e.g. .PNG -> .png)
  if (dealer.image) {
    const dotIndex = dealer.image.lastIndexOf(".");
    if (dotIndex !== -1) {
      const name = dealer.image.slice(0, dotIndex);
      const ext = dealer.image.slice(dotIndex).toLowerCase();
      imageName = name + ext;
    }
  }
    card.innerHTML = `
      <figure>
        <a href="${websiteUrl}" target="_blank" rel="noopener">
          <img 
            src="https://cdn.shopify.com/s/files/1/0727/9591/4497/files/${imageName}" 
            width="421" 
            height="176" 
            alt="${dealer.company || ""}"
            onerror="this.onerror=null;this.src='https://cdn.shopify.com/s/files/1/0727/9591/4497/files/tempest-logo.svg?v=1749618687';"
          >
        </a>
      </figure>
      <div class="card-content">
        <div class="card-header">
          ${dealer.company ? `<h6><a href="${websiteUrl}" target="_blank" rel="noopener">${dealer.company}</a></h6>` : ""}
        </div>
          ${
            dealer.address
              ? `<span class="distance">${dealer.address}</span>`
              : ""
          }
        ${
          dealer.description
            ? `<p class="subtitle">${dealer.description}</p>`
            : ""
        }
        ${
          dealer.status || dealer.opens_at
            ? `<p class="status">
                ${
                  dealer.status
                    ? `<span class="closed">${dealer.status}</span>`
                    : ""
                }
                ${dealer.opens_at ? `until ${dealer.opens_at}` : ""}
                <span class="separator">·</span> Office
              </p>`
            : ""
        }
        <div class="card-buttons">
        ${
          dealer.direction
            ? `<a target="_blank" href="${dealer.direction}" class="button">Directions</a>`
            : ""
        }
           ${
             dealer.site
               ? `<a href="${websiteUrl}" class="button btn-secondary" target="_blank" rel="noopener">Website</a>`
               : ""
           }
          ${
            dealer.phone
              ? `<a href="tel:${dealer.phone.toString().replace(/\D/g, '')}" class="button btn-black">Call</a>`
              : ""
          }
        </div>
      </div>
    `;
    grid.appendChild(card);
  });

  const totalPages = Math.ceil(currentDealers.length / dealersPerPage);
  loadMoreBtn.style.display =
    currentPage < totalPages ? "inline-block" : "none";

  hideLoader();
}

function filterDealers(search = "", dealerType = "") {
  const filtered = window.dealerData.filter((dealer) => {
    const matchesType = !dealerType || dealer.type.toLowerCase() === dealerType;
    const matchesSearch =
      !search ||
      dealer.zip_code.toLowerCase().includes(search) ||
      dealer.address.toLowerCase().includes(search) ||
      dealer.company.toLowerCase().includes(search);

    return matchesType && matchesSearch;
  });

  renderDealers(filtered, true);
}

// Call this function from inline <script> after data is fetched
function handleDealerFiltering() {
  const searchParam = getQueryParam("search").toLowerCase();
  if (searchParam) {
    const zipInput = document.querySelector(".zip-input");
    if (zipInput) zipInput.value = searchParam;
    filterDealers(searchParam);
  } else {
    renderDealers(window.dealerData, true);
  }

  // Bind button event
  document
    .querySelector("#tab1 .dealer-btn button")
    ?.addEventListener("click", function (e) {
      e.preventDefault();
      const dealerType = document
        .querySelector(".dealer-type")
        ?.value.toLowerCase();
      const zipInput = document
        .querySelector(".zip-input")
        ?.value.toLowerCase();
      filterDealers(zipInput, dealerType);
    });

  document
    .querySelector("#tab2 .dealer-btn button")
    ?.addEventListener("click", function (e) {
      e.preventDefault();

      const filtered = window.dealerData.filter((dealer) => {
        return Object.keys(state.selected).every((key) => {
          return (
            !state.selected[key] ||
            dealer[selects[key].key] === state.selected[key]
          );
        });
      });

      renderDealers(filtered, true);
    });
}

// for second tab

function initDynamicDealerFilters() {
  function getFilteredDealersForKey(filterKey) {
    return window.dealerData.filter((dealer) => {
      return Object.keys(state.selected).every((key) => {
        if (key === filterKey) return true; // Don't filter by self
        return (
          !state.selected[key] ||
          dealer[selects[key].key] === state.selected[key]
        );
      });
    });
  }

  function renderSelect({ selector, key, label }) {
    const nodes = document.querySelectorAll(selector);
    let optionsSet;

    if (key === "type") {
      optionsSet = new Set(
        window.dealerData.map((d) => d[key]).filter(Boolean)
      );
    } else {
      const filteredDealers = getFilteredDealersForKey(key);
      optionsSet = new Set(filteredDealers.map((d) => d[key]).filter(Boolean));
    }

    const currentValue = state.selected[key];

    if (currentValue && !optionsSet.has(currentValue)) {
      optionsSet.add(currentValue);
    }

    const allOptions = Array.from(optionsSet).sort();

    nodes.forEach((select) => {
      select.innerHTML = `<option value="">${label}</option>`;
      allOptions.forEach((val) => {
        const selected = val === currentValue ? "selected" : "";
        select.innerHTML += `<option value="${val}" ${selected}>${val}</option>`;
      });
    });
  }

  function updateAllDropdowns(changedKey) {
    // showLoader(); // start loader
    setTimeout(() => {
      const validDealers = window.dealerData.filter((dealer) => {
        return Object.keys(state.selected).every((key) => {
          return (
            !state.selected[key] ||
            dealer[selects[key].key] === state.selected[key]
          );
        });
      });
      const fallbackState = validDealers.length
        ? state.selected
        : {
            ...state.selected,
            [changedKey]: "",
          };

      for (const key in selects) {
        let optionsSet;

        if (key === "type") {
          optionsSet = new Set(
            window.dealerData.map((d) => d[selects[key].key]).filter(Boolean)
          );
        } else {
          const filtered = window.dealerData.filter((dealer) => {
            return Object.keys(fallbackState).every((k) => {
              if (k === key) return true;
              return (
                !fallbackState[k] || dealer[selects[k].key] === fallbackState[k]
              );
            });
          });

          optionsSet = new Set(
            filtered.map((d) => d[selects[key].key]).filter(Boolean)
          );
        }

        const currentValue = state.selected[key];

        const nodes = document.querySelectorAll(selects[key].selector);
        nodes.forEach((select) => {
          select.innerHTML = `<option value="">${selects[key].label}</option>`;
          Array.from(optionsSet)
            .sort()
            .forEach((val) => {
              const selected = val === currentValue ? "selected" : "";
              select.innerHTML += `<option value="${val}" ${selected}>${val}</option>`;
            });
        });
      }
      // renderDealers(validDealers);
      hideLoader(); // end loader
    }, 200); // delay is optional to ensure smoothness
  }

  function bindEvents() {
    for (const key in selects) {
      const nodes = document.querySelectorAll(selects[key].selector);
      nodes.forEach((select) => {
        select.addEventListener("change", (e) => {
          const value = e.target.value;
          state.selected[key] = value;

          if (key === "type") {
            state.selected.state = "";
            state.selected.rep = "";
          } else if (key === "state") {
            state.selected.rep = "";
          }

          updateAllDropdowns(key);
        });
      });
    }
  }

  function filterDealersFromFilters() {
    const filtered = window.dealerData.filter((dealer) => {
      return Object.keys(state.selected).every((key) => {
        // return !state.selected[key] || dealer[key] === state.selected[key];
        return (
          !state.selected[key] ||
          dealer[selects[key].key] === state.selected[key]
        );
      });
    });
    renderDealers(filtered, tr);
  }

  for (const key in selects) {
    renderSelect(selects[key]);
  }
  bindEvents();
}
